import type { CAPRouter } from "@phc/cap-service"
import { createTRPCClient, httpBatchLink } from "@trpc/client"
import { useEffect } from "react"
import superjson from "superjson"
import useAuth from "../utils/auth"
import { CAP_URL } from "../utils/constants"

let getAccessToken: (() => Promise<string>) | undefined

const apiClient = createTRPCClient<CAPRouter>({
  links: [
    httpBatchLink({
      transformer: superjson,
      maxURLLength: 2083,
      url: `${CAP_URL}/trpc`,
      headers: async () => {
        if (getAccessToken) {
          const token = await getAccessToken()
          return {
            Authorization: `Bearer ${token}`,
          }
        }
        return {}
      },
    }),
  ],
})

export function useCapClient() {
  const { getAccessTokenSilently, isAuthenticated } = useAuth()

  useEffect(() => {
    if (isAuthenticated) {
      getAccessToken = getAccessTokenSilently
    } else {
      getAccessToken = undefined
    }
  }, [isAuthenticated, getAccessTokenSilently])

  return apiClient
}
